// eslint-disable-next-line import/no-extraneous-dependencies
import { createAction } from 'redux-actions';

export const getArticleGroupsRequest = createAction('GET_ARTICLE_GROUPS_REQUEST');
export const getArticleGroupsSuccess = createAction('GET_ARTICLE_GROUPS_SUCCESS');
export const getArticleGroupsFailure = createAction('GET_ARTICLE_GROUPS_FAILURE');

export const getFieldGroupsRequest = createAction('GET_FIELD_GROUPS_REQUEST');
export const getFieldGroupsSuccess = createAction('GET_FIELD_GROUPS_SUCCESS');
export const getFieldGroupsFailure = createAction('GET_FIELD_GROUPS_FAILURE');

export const getTrademarkGroupsRequest = createAction('GET_TRADEMARK_GROUPS_REQUEST');
export const getTrademarkGroupsSuccess = createAction('GET_TRADEMARK_GROUPS_SUCCESS');
export const getTrademarkGroupsFailure = createAction('GET_TRADEMARK_GROUPS_FAILURE');

export const createGroupRequest = createAction('CREATE_GROUP_REQUEST');
export const createGroupSuccess = createAction('CREATE_GROUP_SUCCESS');
export const createGroupFailure = createAction('CREATE_GROUP_FAILURE');
export const resetCreateGroupState = createAction('RESET_CREATE_GROUP_STATE');

export const updateGroupRequest = createAction('UPDATE_GROUP_REQUEST');
export const updateGroupSuccess = createAction('UPDATE_GROUP_SUCCESS');
export const updateGroupFailure = createAction('UPDATE_GROUP_FAILURE');
export const resetUpdateGroupState = createAction('RESET_UPDATE_GROUP_STATE');

export const deleteGroupRequest = createAction('DELETE_GROUP_REQUEST');
export const deleteGroupSuccess = createAction('DELETE_GROUP_SUCCESS');
export const deleteGroupFailure = createAction('DELETE_GROUP_FAILURE');
export const resetDeleteGroupState = createAction('RESET_DELETE_GROUP_STATE');

export const resetGroupState = createAction('RESET_GROUP_STATE');
